module.exports = __webpack_public_path__ + "static/images/index_box_btn.4aa10d5.jpg";